// PDP bundle upsell strip (UBB-414). Shows/hides the nudge bar between the size picker and
// buy blocks based on the selected variant title matching the strip's `data-trigger` value
// (case-insensitive exact match). Initial visibility is server-set (hidden attr); this module
// only handles subsequent size changes.
// Document-delegated + idempotent. Bundled via the objects barrel (index.js → global.autojs.js),
// so it runs on all pages including collection/search pages where the quickview modal is opened.

const STRIP = '[data-bundle-upsell]';
const SIZE_INPUT = '.product-info__size-input';

function getSelectedTitle(input) {
  const label = input.closest('label');
  const titleEl = label && label.querySelector('.product-info__size-title');
  return titleEl ? titleEl.textContent.trim() : '';
}

function syncStrip(strip, selectedTitle) {
  const trigger = (strip.dataset.trigger || '').toLowerCase().trim();
  strip.hidden = selectedTitle.toLowerCase() !== trigger;
}

// Global sync — used on the PDP and for document-delegated change events.
function syncAllStrips(selectedTitle) {
  document
    .querySelectorAll(STRIP)
    .forEach((strip) => syncStrip(strip, selectedTitle));
}

// Scoped sync — used when seeding a quickview modal on open. Reads the checked
// input within `root` and syncs only the strips within that same root, so a
// modal showing product B doesn't bleed into the PDP showing product A.
function syncStripsInRoot(root) {
  const checkedInput = root.querySelector(`${SIZE_INPUT}:checked`);
  if (!checkedInput) return;
  const selectedTitle = getSelectedTitle(checkedInput);
  root
    .querySelectorAll(STRIP)
    .forEach((strip) => syncStrip(strip, selectedTitle));
}

function onChange(event) {
  const target = event.target;
  if (!target || !target.matches(SIZE_INPUT)) return;
  syncAllStrips(getSelectedTitle(target));
}

// UBB-421: watch a quickview modal's inject container. quick-add.js sets
// modalContent.innerHTML on open and clears it on hide(), so childList on
// that node is the open/close signal (same pattern as loop-widget-quickview.js).
// On inject, seed the strip from the modal's own checked input, scoped to
// that modal — the server-rendered hidden attr reflects the default variant,
// but may not match the variant the shopper had selected when they opened it.
function watchModal(modal) {
  const content = modal.querySelector('[id^="QuickAddInfo-"]');
  if (!content || content.dataset.bundleUpsellWatched === 'true') return;
  content.dataset.bundleUpsellWatched = 'true';

  const observer = new MutationObserver(() => {
    if (!content.children.length) return; // hide() cleared it — nothing to do
    syncStripsInRoot(content);
  });
  observer.observe(content, { childList: true });
}

function initBundleUpsell() {
  if (window.__bundleUpsellInit) return;
  window.__bundleUpsellInit = true;

  // Seed from the currently checked input — covers ?variant= deep-links where the
  // server-selected variant may differ from the block's default.
  const checkedInput = document.querySelector(`${SIZE_INPUT}:checked`);
  if (checkedInput) syncAllStrips(getSelectedTitle(checkedInput));

  document.addEventListener('change', onChange);

  // Capture-phase click: attach the MutationObserver before ModalOpener's own
  // click handler starts the fetch, so the observer is ready when innerHTML is set.
  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target.closest?.('modal-opener[data-modal]');
      if (!opener) return;
      const selector = opener.getAttribute('data-modal');
      if (!selector) return;
      let modal;
      try {
        modal = document.querySelector(selector);
      } catch {
        return; // malformed selector — nothing to do
      }
      if (modal && modal.tagName === 'QUICK-ADD-MODAL') watchModal(modal);
    },
    true
  );
}

document.addEventListener('DOMContentLoaded', initBundleUpsell);
